// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as FunctionExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/function.svg?react';
import { createIcons } from '../../Icon';
const FunctionIcon = /* @__PURE__ */ createIcons('Function', {
    extended: FunctionExtended
});
FunctionIcon.supportedTypes = [
    'extended'
];
FunctionIcon.category = 'entities';
export default FunctionIcon;
